import { render } from "./ArrowRightIcon.vue?vue&type=template&id=3d86b1ba"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__